import {Component, OnInit} from '@angular/core';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {ControlContainer, NgForm} from '@angular/forms';

@Component({
    selector: 'app-warranty-notes-editor',
    templateUrl: './warranty-notes-editor.component.html',
    styleUrls: ['./warranty-notes-editor.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class WarrantyNotesEditorComponent extends EditModalSectionBaseComponent {

    constructor(public  editModalService: EditModalService) {
        super(editModalService);
    }
}
